const baseUrl = process.env.REACT_APP_SIE_APP_PROXY_BASE_URL;
// const baseUrl = " http://127.0.0.1:3000"
const TOKEN_KEY = "Bearer";

export const getResourceAccess = async (bodyRequest: object) => {
    try {
        const response = await fetch(
            `${baseUrl}/publishing/validate-visit`,
            // `${baseUrl}/list_training_events`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify(bodyRequest)
            }
        )
        return response;
    } catch (error) {
        return error
    }
}


export const registerVisit = async (bodyRequest: object) => {

    try {
        const response = await fetch(
            `${baseUrl}/publishing/add-visitor`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify(bodyRequest)
            }
        )
        return response;
    } catch (error) {
        return error
    }
}
